export const EventCode = {
	Container: {
		Completed: "Completed",
		Dehired: "Dehired",
		DeliveredTerminal: "DeliveredTerminal"
	}
} as const;
